import React from 'react';
import styled from 'styled-components';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const ArrowIcon = React.memo(function ArrowIcon(props: TArrowIconProps): React.ReactElement {
    const { dir = 'right', ...elementProps } = props;
    return (
        <SIconBase aria-label="Arrow" {...elementProps} $dir={dir}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0671 7.05922C10.7188 6.68953 10.7192 6.11249 11.0678 5.74318C11.4463 5.34216 12.0842 5.34216 12.4628 5.74318L16.7272 10.2608C17.0909 10.6462 17.0909 11.2484 16.7272 11.6337L12.4628 16.1513C12.0842 16.5524 11.4463 16.5524 11.0678 16.1513C10.7192 15.782 10.7188 15.205 11.0671 14.8353L13.7962 11.9378H5.99363C5.44659 11.9378 5.00313 11.4943 5.00313 10.9473C5.00313 10.4002 5.44659 9.95676 5.99363 9.95676H13.7962L11.0671 7.05922Z"
            />
        </SIconBase>
    );
});

export default ArrowIcon;

// #region Styles

const SIconBase = styled(IconBase)<{ $dir: TArrowIconDirection }>`
    path {
        transition: rotate 0.2s ease;
        transform-origin: center;
        rotate: ${(p) =>
            p.$dir === 'left'
                ? '180deg'
                : p.$dir === 'up'
                ? '-90deg'
                : p.$dir === 'down'
                ? '90deg'
                : p.$dir === 'up-right'
                ? '-45deg'
                : 0};
    }
`;

// #endregion

// #region Types

export type TArrowIconDirection = 'right' | 'left' | 'up' | 'down' | 'up-right';

export type TArrowIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>> & {
        dir?: TArrowIconDirection;
    };

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <ArrowIcon />
        : {
              ...IconBaseExample,
              render: ArrowIcon,
              controls: { dir: ['right', 'left', 'up', 'down'], ...IconBaseExample.controls },
          };

// #endregion
